import React from 'react';

function FreeBox(props) {
    return (
        <div className={props.className}>
            <div
                className="rounded-lg border border-gray-200 dark:border-gray-600 p-2 hover:shadow-md transition-shadow duration-200 mb-2">
                {props.children}
            </div>
        </div>
    );
}

export default FreeBox;